<div class="w-full h-screen flex">
  <div
    class="flex flex-col min-h-full w-full md:w-9/12 justify-center relative"
  >
    <div
      class="flex justify-center items-center px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24"
    >
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <h1 class="mb-2 text-lg font-semibold leading-6 text-gray-900">
          Central de Suporte
        </h1>
        <p class="mb-6 text-sm text-gray-600">
          Informe o e-mail da sua conta Aprova para acessar a central de
          suporte.
        </p>

        <label
          for="email"
          class="block mb-2 text-sm font-medium leading-6 text-gray-900"
        >
          E-mail
        </label>
        <input
          id="email"
          type="email"
          placeholder="nome@exemplo.com.br"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-aprova focus:border-aprova block w-full p-2.5"
          [formControl]="emailFormControl"
          (keyup.enter)="findCities()"
        />
        @if (emailFormControl.touched && emailFormControl.invalid) {
        <p class="mt-2 text-sm text-red-600">Informe um e-mail válido</p>
        }

        @if (cities().length > 1) {
        <label
          for="cities"
          class="block mt-4 mb-2 text-sm font-medium leading-6 text-gray-900"
        >
          Seu e-mail possui conta em mais de uma cidade. Selecione por onde
          deseja entrar:
        </label>
        <select
          id="cities"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-aprova focus:border-aprova block w-full p-2.5"
          [formControl]="cityFormControl"
          (change)="selectCity()"
        >
          <option selected value="">Selecione a cidade</option>
          @for (city of cities(); track city.identity) {
          <option value="{{ city.identity }}">
            {{ city.name }} - {{ city.state }}
          </option>
          }
        </select>
        } @else {
        <button
          type="button"
          class="mt-4 w-full rounded-lg bg-aprova p-2.5 text-sm font-medium text-white disabled:opacity-60"
          [disabled]="loading()"
          (click)="findCities()"
        >
          {{ loading() ? 'Verificando...' : 'Continuar' }}
        </button>
        }

        @if (errorMessage()) {
        <p class="mt-4 text-sm text-red-600">{{ errorMessage() }}</p>
        }
      </div>
    </div>
    <div class="pylon-footer">
      <a href="https://aprova.com.br/" target="_blank">
        <span class="text-xs text-gray-600">Powered by</span>
        <img src="/assets/images/logo.svg" alt="aprova-logo" />
      </a>
    </div>
  </div>
  <div class="relative hidden w-full md:block bg-gray-200">
    <img
      class="absolute inset-0 h-full w-full object-cover"
      src="/assets/images/cover-login.jpg"
      alt="Cover"
    />
  </div>
</div>
